import React, { Component } from 'react'
import { observer } from "mobx-react";
import IconsContainer from "Utils/IconsContainer";
import 'Styles/commonComponents/RadioButtonList.scss';

class RadioButtonList extends Component {

    selectorId(item) {
        return this.props.selectorId == null
            ? item.id
            : this.props.selectorId(item);
    }

    selectorTitle(item) {
        return this.props.selectorTitle == null
            ? item.title
            : this.props.selectorTitle(item);
    }

    render() {
        return (
            <div className="radio-button-list" >
                {this.props.items == null ? "" :
                    this.props.items.map(item =>
                        <div
                            key={this.selectorId(item)}
                            className="radio-button-list-item"
                            onClick={_ => this.props.onItemSelected(this.selectorId(item))}>
                            <div className="radio-button-list-item-check-icon">
                                {this.props.getSelectedItemId() == this.selectorId(item)
                                    ? IconsContainer.Get('ca-radiobutton-on')
                                    : IconsContainer.Get('ca-radiobutton-off')
                                }
                            </div>
                            <div className="radio-button-list-item-text">
                                <div>
                                    {this.selectorTitle(item)}
                                </div>
                            </div>                            
                        </div>
                    )
                }
            </div>
        )
    }
};

export default observer(RadioButtonList);